module.exports = __webpack_public_path__ + "img/logos.73ee724a.png";